import {
	resumeLastDestination,
	resumePendingContinuation,
} from "./continueAfterAuth";
import { PWA_SHELL_STORAGE } from "./config";

let deferredPrompt = null;
const listeners = new Set();
let initialized = false;

export const getDeferredInstallPrompt = () => deferredPrompt;

export const clearDeferredInstallPrompt = () => {
	deferredPrompt = null;
	listeners.forEach((listener) => listener(null));
};

export const subscribeInstallPrompt = (listener) => {
	listeners.add(listener);
	listener(deferredPrompt);
	return () => listeners.delete(listener);
};

const tryResumeBootDestination = () => {
	if (resumePendingContinuation()) return true;
	return resumeLastDestination();
};

/**
 * Capture beforeinstallprompt early so it survives navigation to InstallPage.
 * Safe to call multiple times.
 * @returns {boolean} true when a pending/last resume already started location.replace
 */
export const initShellPwa = () => {
	if (typeof window === "undefined") return false;

	if (initialized) {
		return sessionStorage.getItem(PWA_SHELL_STORAGE.navLock) === "1";
	}
	initialized = true;

	// Installed PWA often opens at start_url "/" — resume pending, else last destination.
	const resumed = tryResumeBootDestination();
	window.addEventListener("pageshow", () => tryResumeBootDestination());
	window.addEventListener("focus", () => tryResumeBootDestination());

	window.addEventListener("beforeinstallprompt", (event) => {
		event.preventDefault();
		deferredPrompt = event;
		listeners.forEach((listener) => listener(event));
	});

	window.addEventListener("appinstalled", () => {
		deferredPrompt = null;
		listeners.forEach((listener) => listener(null));
	});

	return resumed;
};
